import {dateConvert}         from "../../../plugins/utils";
import reservation_resources from "../../base/reservation_resources";
import moment from 'moment';

const resources = {
    ...reservation_resources,
    pickup_hours      : {
        '__remote': true,
        query     : (state) => ({
            date_pickup: dateConvert(state.model.reservation.date_pickup) || moment().format('MM/DD/YYYY'),
            pickup_day : state.model.reservation.pickup_day
        }),
    }
};

export default resources;
